import { en } from './en'
import { fr } from './fr'

export const bookADemo = { en, fr }
